import React from 'react';
import { Button, Form, Offcanvas } from "react-bootstrap";
import MultiSelect from '../../components/MultiSelect';
import SearchSelect from '../../components/SearchSelect';
const TeamFilter = ({ show, close }) => {
    return (
        <>
            <Offcanvas show={show} onHide={close} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        Team Filter
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>League:</Form.Label>
                            {/* <Form.Select>
                                <option value="">League 1</option>
                                <option value="">League 2</option>
                                <option value="">League 3</option>
                            </Form.Select> */}
                            <SearchSelect
                                options={
                                    [
                                        { value: 'League 1', label: 'League 1' },
                                        { value: 'League 2', label: 'League 2' },
                                        { value: 'League 3', label: 'League 3' }
                                    ]
                                }
                                placeholder={"Search by League"}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Team:</Form.Label>
                            <SearchSelect
                                options={
                                    [
                                        { value: 'Team', label: 'Team' },
                                        { value: 'Team', label: 'Team' },
                                        { value: 'Team', label: 'Team' }
                                    ]
                                }
                                placeholder={"Search by Team"}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>PSL Paid Off:</Form.Label>
                            <Form.Control type="text" placeholder="Search by PSL Paid Off" />
                        </Form.Group>

                    </Form>
                </Offcanvas.Body>
                <Offcanvas.Header>
                    <div className="col-6">
                        <Button variant="primary" className="text-white w-100 fw-bold">
                            Reset
                        </Button>
                    </div>
                    <div className="col-6">
                        <Button variant="primary" onClick={close} className="text-white w-100 fw-bold">
                            Filter
                        </Button>
                    </div>
                </Offcanvas.Header>
            </Offcanvas>
        </>
    );
};

export default TeamFilter;